import React from 'react';

import { closestCenter, DndContext, type DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import type { TaskFormTableRow } from 'src/store/adminConfigPageSlice/regionTasksPageSlice/types';

import SortableRegionTaskRow from './sortableRegionTaskRow';

// **** Types **** //

export interface SortableRegionTaskListProps {
  dataRows: TaskFormTableRow[];
  updateDataRowOrder: (oldIndex: number, newIndex: number) => void;
  onClickEdit: (index: number) => void;
}

// **** Components **** //

/**
 * Default component.
 */
const SortableRegionTaskList = ({ dataRows, updateDataRowOrder, onClickEdit }: SortableRegionTaskListProps) => {
  const sensors = useSensors(useSensor(PointerSensor));

  const handleDragEnd = (event: DragEndEvent) => {
    if (!event.over) return;
    const target = event.activatorEvent.target as HTMLElement;
    const isButtonClick = !!target.closest('button');
    const oldIndex = event.active.data.current?.sortable.index;
    const newIndex = event.over?.data.current?.sortable.index;
    return !isButtonClick ? updateDataRowOrder(oldIndex, newIndex) : onClickEdit(oldIndex);
  };

  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
      <SortableContext items={dataRows.map((item) => item.entityId)} strategy={verticalListSortingStrategy}>
        {dataRows.map((task) => (
          <SortableRegionTaskRow row={task} key={task.entityId} />
        ))}
      </SortableContext>
    </DndContext>
  );
};

// **** Export **** //

export default SortableRegionTaskList;
